export default __webpack_public_path__ + "static/media/prison.ca68d3f3.jpg";